import { CardSize } from "antd/es/card/Card";
import { ReactNode } from "react";
import CardStyle from "./AuthUserCard.style";

interface Cardprops {
  children?: ReactNode;
  loading?: boolean;
  bordered?: boolean;
  size?: CardSize;
  title?: string;
  className?: string;
}

function AuthUserCard(props:Readonly<Cardprops>) {
  const { children, loading, bordered, title, size, className } = props;
  return (
    <CardStyle
      title={title}
      loading={loading}
      bordered={bordered}
      className={className}
      size={size}
    >
      {children}
    </CardStyle>
  );
}

export default AuthUserCard;
